import type { Ref } from 'react'
import {
  CustomSelect,
  type RenderSearchItemProps,
} from '@/components/inputs/CustomSelect'
import { useCustomSelectStateFromItemSource } from '@/components/inputs/item-source-hook'
import { SearchResultItem } from '@/components/inputs/SearchResultItem'
import { observer } from 'mobx-react-lite'
import { truncate } from 'lodash-es'
import { type ClientTeamInputEditorViewModel } from './ClientTeamInputEditorViewModel'
import { type TeamMember } from '@/features/iam/teams/TeamMember'
import { ClientTeamInputEditor } from '@/features/jobs/TransferJobDialog/ClientTeamInputEditor'

export interface ClientTeamInputEditorContainerProps {
  vm: ClientTeamInputEditorViewModel
}

export const ClientTeamInputEditorContainer = observer(
  function ClientTeamInputEditorContainer({
    vm,
  }: ClientTeamInputEditorContainerProps) {
    const selectClientTeamProps = useCustomSelectStateFromItemSource({
      itemSource: vm.fetchClientTeamMembers,
      debounce: 250,
    })

    return (
      <ClientTeamInputEditor
        error={vm.validationClientTeamMember.getError('clientTeamMember')}
        clientTeamSelect={
          <CustomSelect
            {...selectClientTeamProps}
            testId="transfer-to-client-team-dropdown"
            multi={false}
            itemToString={(i) => truncate(i.team.name, { length: 60 })}
            placeholder="Select new client team"
            value={vm.clientTeamMember}
            onChange={vm.setClientTeamMember}
            renderSearchItem={(props) => (
              <TransferToClientTeamSearchItemContainer {...props} />
            )}
          />
        }
      />
    )
  },
)

interface TransferToClientTeamSearchItemContainerProps extends RenderSearchItemProps<TeamMember> {
  ref?: Ref<HTMLDivElement>
}

const TransferToClientTeamSearchItemContainer = observer(
  function TransferToClientTeamSearchItemContainer({
    item,
    itemToString: _itemToString,
    ref,
    ...itemProps
  }: TransferToClientTeamSearchItemContainerProps) {
    return (
      <SearchResultItem
        ref={ref}
        {...itemProps}
        testId={
          'transfer-to-client-team-option-' +
          (item?.team.id?.toLowerCase() || item?.team.name.toLowerCase())
        }
      >
        {item?.team.name}
      </SearchResultItem>
    )
  },
)
